export default "/assets/images/slide-mini-sm.197893e35051cf36.jpg";